module.exports = "/_next/static/images/4c8ad2e7b0a00d770562006957f7c6b3-comunidad-nu-xs.jpg.webp";